import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constants } from '../app.constants';

@Injectable({
  providedIn: 'root'
})

export class BooksService {

  constructor(private httpClient: HttpClient) { }

  getAll(type:string) {
    if(type == 'books')
      return this.httpClient.get<BookVM[]>(Constants.books);
    else
      return this.httpClient.get<BookVM[]>(Constants.pothis);

  }
}

export class BookVM {
  constructor(
    booksId: number,
    name: string,
    author: string,
    date: Date,
    publisher: string,
    bookabstract: string,
    footer: string,
    coverthmpath: string,
    coverbigpath: string,
    bookpath: string,
    createdon: Date,
  ) {
    this.booksId = booksId;
    this.name = name;
    this.author = author;
    this.date = date;
    this.publisher = publisher;
    this.bookabstract = bookabstract.replaceAll("0123456789","<br>");
    this.footer = footer.replaceAll("0123456789","<br>");
    this.coverthmpath = coverthmpath;
    this.coverbigpath = coverbigpath;
    this.bookpath = bookpath;
    this.createdon = createdon;
  }
  booksId: number;
  name: string;
  author: string;
  date: Date;
  publisher: string;
  bookabstract: string;
  footer: string;
  coverthmpath: string;
  coverbigpath: string;
  bookpath: string;
  createdon: Date;
}
